import { useTheme } from '@/components/ThemeProvider';
import { ReactNode } from 'react';
import Navbar from './Navbar';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-300 via-slate-100 to-slate-300 dark:from-slate-900 dark:via-slate-600 dark:to-slate-800 flex flex-col">
      {/* Main content area */}
      <div className="relative z-10">
        <Navbar />
        <main
          className="w-full h-[calc(100vh-102px)]"
          style={{ marginTop: '102px' }}>
          <div className="w-full max-w-none p-6 sm:px-6 lg:px-6 h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
